"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var WidgetTokenDropArea_1 = require("../WidgetTokenDropArea/WidgetTokenDropArea");
var VariableActions_1 = require("Project/QwilrEditor/Behaviours/VariableActions");
var styles = __importStar(require("./EmbedRegistryWidgetEmbedWidget.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var EmbedRegistryWidgetEmbedWidget = (function (_super) {
    __extends(EmbedRegistryWidgetEmbedWidget, _super);
    function EmbedRegistryWidgetEmbedWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.dropAreaWidthInPixels = 0;
        _this.getEmbeddedComponent = function () {
            if (_this.props.embedUrl) {
                return (react_1.default.createElement("div", { className: "embed-widget__iframe-container" },
                    react_1.default.createElement("iframe", { src: _this.props.embedUrl, className: "embed-widget__iframe" }),
                    _this.props.showPlaceholderAsOverlay && (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", align: "center", className: styles.overlay },
                        react_1.default.createElement("div", { className: styles.overlayInner }, _this.props.placeholder)))));
            }
            else if (_this.props.allowVariables && !_this.props.showPlaceholderInsteadOfTokenDropArea) {
                return _this.renderDropArea();
            }
            else {
                return _this.props.placeholder;
            }
        };
        _this.renderDropArea = function () {
            var _a;
            var _b = _this.props, isSelected = _b.isSelected, variableDetails = _b.variableDetails;
            if (!variableDetails) {
                return null;
            }
            return (react_1.default.createElement(WidgetTokenDropArea_1.WidgetTokenDropArea, { isSelected: isSelected, onDrop: _this.onTokenDrop, variableName: (_a = variableDetails.variable) === null || _a === void 0 ? void 0 : _a.label, icon: variableDetails.icon, instructions: variableDetails.instructions, size: WidgetTokenDropArea_1.WidgetTokenDropAreaSize.Auto }));
        };
        _this.updateDropAreaWidthInPixels = function () {
            if (_this.dropAreaElem) {
                var dropAreaRect = _this.dropAreaElem.getBoundingClientRect();
                if (dropAreaRect.width !== _this.dropAreaWidthInPixels) {
                    _this.dropAreaWidthInPixels = dropAreaRect.width;
                }
            }
        };
        _this.onTokenDrop = function (event) {
            var variable = (0, VariableActions_1.getVariableTokenFromDragEvent)(event);
            if (!variable) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            _this.props.triggerWidgetEvent({
                action: "dropVariable",
                path: _this.props.widgetManager.getPath(_this.props.element),
                variable: variable,
            });
        };
        return _this;
    }
    EmbedRegistryWidgetEmbedWidget.prototype.componentDidUpdate = function (prevProps) {
        this.updateDropAreaWidthInPixels();
    };
    EmbedRegistryWidgetEmbedWidget.prototype.render = function () {
        var _a = this.props, children = _a.children, isResizing = _a.isResizing;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)({
                    "embed-widget": true,
                    "embed-widget--not-focused": !this.embedWidgetIsSelected || isResizing,
                    "embed-widget--selected": this.embedWidgetIsSelected,
                }, "embed-widget--margins-disabled", styles.embedWrapper), contentEditable: false }, this.getEmbeddedComponent()),
            children));
    };
    Object.defineProperty(EmbedRegistryWidgetEmbedWidget.prototype, "embedWidgetIsSelected", {
        get: function () {
            return this.props.isSelected;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], EmbedRegistryWidgetEmbedWidget.prototype, "dropAreaElem", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], EmbedRegistryWidgetEmbedWidget.prototype, "dropAreaWidthInPixels", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EmbedRegistryWidgetEmbedWidget.prototype, "updateDropAreaWidthInPixels", void 0);
    EmbedRegistryWidgetEmbedWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], EmbedRegistryWidgetEmbedWidget);
    return EmbedRegistryWidgetEmbedWidget;
}(react_1.default.Component));
exports.default = EmbedRegistryWidgetEmbedWidget;
